import { Component, OnDestroy, OnInit } from '@angular/core';
import { filter, Subject, takeUntil } from 'rxjs';
import { ClientStateService } from 'src/app/core/services/client-state.service';
import { PortalStateService } from 'src/app/core/services/portal-state.service';
import { DestinyViewType, DestinyViewTypeVO } from 'src/portaljs/constants/destiny-view-type';

@Component({
  selector: 'fss-portal-view-type-select',
  templateUrl: './view-type-select.component.html',
  styleUrls: ['./view-type-select.component.scss'],
  standalone: false
})
export class ViewTypeSelectComponent implements OnInit, OnDestroy {

  public selectedViewType: DestinyViewType = DestinyViewType.ALL;
  private ngUnsubscribe = new Subject<void>();
  public viewTypes: DestinyViewType[] = [];


  public getIsDestinyViewSelectorEnabled(): boolean {
    return this.portalStateService.getIsDestinyViewSelectorEnabled();
  }


  public setSelectedViewType(value: string): void;
  public setSelectedViewType(value: DestinyViewType): void {
    this.portalStateService.sendDestinyViewTypeChange(value);
  }

  constructor(
    private readonly portalStateService: PortalStateService,
    private readonly clientStateService: ClientStateService
  ) {}

  public ngOnInit(): void {
    this.updateSelectedViewTypeValue();
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private updateSelectedViewTypeValue() {
    this.clientStateService
      .getDestinyViewTypeVO$()
      .pipe(
        filter(x => !!x),
        takeUntil(this.ngUnsubscribe))
      .subscribe((viewTypeVO: DestinyViewTypeVO) => {
        this.viewTypes = viewTypeVO?.viewTypes || [];
        this.selectedViewType = viewTypeVO?.selectedViewType || DestinyViewType.ALL;
      });
  }  
}
